import React, { useEffect } from 'react';
import { Button, Typography } from '@/ui-kit';
import styles from './successful-registration.module.scss';
import { Hand, StartIcon } from '@/assets/icons';
import { callYaMetrika } from '@/utils/call-ya-metrika';
import { callVKPixel } from '@/utils/call-vk-pixel';
import { Trans, useTranslation } from 'react-i18next';
interface Props {
    onClose?: () => void;
}
export const SuccessfulRegistration: React.FC<Props> = ({ onClose }) => {
    useEffect(() => {
        callYaMetrika('you_can_like_it');
        callVKPixel('registration')
    }, []);

    const { t } = useTranslation();

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <div className={styles.illustration}>
                    <StartIcon className={styles['star-1']} />
                    <StartIcon className={styles['star-2']} />
                    <StartIcon className={styles['star-3']} />
                    <Hand className={styles.hand} />
                </div>
                <Typography
                    variant="h2"
                    fontWeight="medium"
                    typeColor="white"
                    center
                    className={styles.title}>
                    {t('registration.you_are_registered')}
                </Typography>
                <Typography
                    variant="p"
                    fontWeight="normal"
                    typeColor="white"
                    center
                    className={styles.text}>
                    <Trans i18nKey="registration.signup_note" />
                </Typography>
                <Button
                    typeColor="orange"
                    link
                    className={styles.button}
                    onClick={onClose}>
                    {t('registration.start')}
                </Button>
            </div>
        </div>
    );
};
